'use strict';

module.exports = {
    initsortmodal: function () {
        $('.container').on('click', '.sort-results', function () {
            $('.js-sort-modal-wrapper').addClass('show');
            $('.search-page').addClass('show-overlay');
        });

        $('.js-sort-modal-wrapper').on('click', '.close', function () {
            $('.js-sort-modal-wrapper').removeClass('show');
            $('.search-page').removeClass('show-overlay');
        });

        $('.sortable-list').on('click', 'li a', function (e) {
            e.preventDefault();
            var $id = $(this).data('id');
            $('.js-sort-order-init option').removeAttr('selected', 'selected');
            $(".js-sort-order-init option[data-id='" + $id + "']").attr(
                'selected',
                'selected'
            );
            $(".js-sort-order-init option[data-id='" + $id + "']").trigger(
                'change'
            );
            $('.js-sort-modal-wrapper').removeClass('show');
        });
    },
    refinementBar: function () {
        $('.container').on('click', 'button.filter-results', function (e) {
            e.preventDefault();
            $('.refinement-bar').toggleClass('show');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.row')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.tab-pane.active')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar')
                .closest('.container.search-results')
                .siblings()
                .attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });
    },
    selectSort: function () {
        $('.container').on(
            'change',
            '.sort-option input[type=radio]',
            function () {
                $('.sort-option').removeClass('checked');
                $(this).parent('.sort-option').addClass('checked');
            }
        );
    }
};
